import React from 'react';
import _ from 'underscore';
import SvgIcon from 'app/blocks/common/svg-icon/svg-icon';

const Method = function () {};
Method.prototype = {
    is(str) {
        // eslint-disable-next-line eqeqeq
        return this == str;
    },
    not(str) {
        return !this.is(str);
    },
    toString() {
        return this.key;
    },
};

const method = {
    CREDIT_CARD: _.extend(new Method(), {
        isAllowedChange(str) {
            return !str || str.length === 0 || method.INVOICE.is(str);
        },
        key: 'CREDIT_CARD',
        logo: (
            <>
                <SvgIcon.visaLogo iconTitle="Visa" seleniumid="visa-payment-logo" />
                <SvgIcon.masterCardLogo iconTitle="MasterCard" seleniumid="master-card-payment-logo" />
                <SvgIcon.americanExpressLogo iconTitle="American Express" seleniumid="amex-payment-logo" />
                <SvgIcon.discoverLogo iconTitle="Discover" seleniumid="discover-payment-logo" />
                <SvgIcon.dinersLogo iconTitle="Diners" seleniumid="diners-payment-logo" />
                <SvgIcon.unionPayLogo iconTitle="UnionPay" seleniumid="unionpay-payment-logo" />
                <SvgIcon.dinaCardLogo iconTitle="DinaCard" seleniumid="dinacard-payment-logo" />
                <SvgIcon.jcbLogo iconTitle="JCB" seleniumid="jcb-payment-logo" />
                <SvgIcon.bcCardLogo iconTitle="BC Card" seleniumid="bccard-payment-logo" />
            </>
        ),
        text: 'Credit card',
    }),
    INVOICE: _.extend(new Method(), {
        isAllowedChange(str) {
            return !str || str.length === 0 || method.INVOICE.is(str);
        },
        key: 'INVOICE',
        text: 'Invoice',
    }),
    PROFORMA: _.extend(new Method(), {
        isAllowedChange(str) {
            return !str || str.length === 0;
        },
        key: 'PROFORMA',
        text: 'Proforma',
    }),
    SOCOPAY: _.extend(new Method(), {
        isAllowedChange(str) {
            return !str || str.length === 0 || method.SOCOPAY.is(str);
        },
        key: 'SOCOPAY',
        logo: (
            <>
                <SvgIcon.alipayLogo iconTitle="Alipay" seleniumid="alipay-payment-logo" />
                <SvgIcon.weChatPayLogo iconTitle="WechatPay" seleniumid="wechat-payment-logo" />
                <SvgIcon.unionPayLogo iconTitle="UnionPay" seleniumid="china-union-payment-logo" />
            </>
        ),
        text: 'Alipay, WeChat Pay, or UnionPay',
    }),
    WAIVED: _.extend(new Method(), {
        isAllowedChange(str) {
            return !str || str.length === 0 || method.WAIVED.is(str);
        },
        key: 'WAIVED',
        text: 'Waived',
    }),
};
method.all = [method.CREDIT_CARD, method.INVOICE, method.PROFORMA, method.SOCOPAY];

function getMethodByKey(key) {
    return _.find(method, function (v) {
        // eslint-disable-next-line eqeqeq
        return v == key;
    });
}

export default {
    getMethodByKey,
    method,
    oaPaymentMethods: [method.CREDIT_CARD, method.INVOICE, method.PROFORMA], // don't replace by all, it will not be obvious what methods are available
    oaPaymentMethodsWithSocopay: [method.CREDIT_CARD, method.INVOICE, method.PROFORMA, method.SOCOPAY],
    oaTransitions: {
        CREDIT_CARD: method.all,
        INVOICE: method.all,
        PROFORMA: method.all,
    },
    oaTransitionsWithSocopay: {
        CREDIT_CARD: method.all,
        INVOICE: method.all,
        PROFORMA: method.all,
        SOCOPAY: method.all,
    },
    ooPaymentMethods: [method.CREDIT_CARD, method.INVOICE],
    ooPaymentMethodsWithSocopay: [method.CREDIT_CARD, method.INVOICE, method.SOCOPAY],
    // TODO is not used any more, remove
    ooTransitions: {
        CREDIT_CARD: [],
        INVOICE: [method.CREDIT_CARD, method.INVOICE],
        PROFORMA: [],
    },
};
